import { Box, Grid, Skeleton } from '@mui/material';
import { ProfilePageHeaderSkeleton } from '../../shared/ProfilePageHeaderSkeleton';
import { profilePageStyles } from '../../styles';

export const EducationPageSkeleton: React.FC = () => {
  return (
    <Box>
      <ProfilePageHeaderSkeleton />
      <Box sx={profilePageStyles.profileCard}>
        <Grid container spacing={2.5}>
          <Grid item>
            <Skeleton variant="circular" height="5rem" width="5rem" />
          </Grid>
          <Grid item xs>
            <Skeleton
              sx={{ mb: 1.5, maxWidth: 1 }}
              variant="rectangular"
              height="2rem"
              width="clamp(15rem, 25rem, 30rem)"
            />
            <Skeleton sx={{ mb: 3, maxWidth: 1 }} width="clamp(10rem, 20rem, 25rem)" />
            <Skeleton sx={{ mb: 1 }} width="7.5rem" />
            <Grid container alignItems="center" spacing={2.5}>
              <Grid item>
                <Skeleton width="7.5rem" />
              </Grid>
              <Grid item>
                <Skeleton variant="rectangular" height="2.25rem" width="10rem" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
